import * as React from "react";
import { observer } from "mobx-react-lite";
import { structure } from "@/endpoints/dryp/structure";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { DialogTitle } from "@radix-ui/react-dialog";

import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { useStore } from "@/hooks/useStore";
import { DialogHeader } from "@/components/ui/dialog";

interface EditNetworkTypeProps {
	structureId: Dryp.StructureId;
	onSuccess: () => void;
	structureNetworkType?: Dryp.NetworkType;
}

export const EditNetworkType: React.FC<EditNetworkTypeProps> = observer(
	({ structureId, onSuccess, structureNetworkType }) => {
		const api = useAsyncStateStore(structure.editStructure);

		const {
			uiStore: { modalStore },
		} = useStore();

		const defaultNetworkType = structureNetworkType || "unknown";
		const [networkType, setNetworkType] = React.useState<Dryp.NetworkType>(defaultNetworkType);

		const onSave = async () => {
			await api.fetch({ structureId, networkType });
			onSuccess();
			modalStore.close();
		};

		return (
			<>
				<DialogHeader>
					<DialogTitle className=" font-bold text-lg">Edit network type</DialogTitle>
				</DialogHeader>
				<div className="flex flex-col gap-6">
					<div className="flex flex-col gap-4">
						<div className="flex flex-col gap-1">
							<Label htmlFor="networkType">Select network type</Label>

							<Select value={networkType} onValueChange={v => setNetworkType(v as Dryp.NetworkType)}>
								<SelectTrigger id="networkType" className="w-full">
									<SelectValue placeholder="Select network type" />
								</SelectTrigger>

								<SelectContent>
									<SelectItem value="unknown">Unknown</SelectItem>
									<SelectItem value="waste">Waste</SelectItem>
									<SelectItem value="rain">Rain</SelectItem>
									<SelectItem value="combined">Combined</SelectItem>
								</SelectContent>
							</Select>
						</div>

						<div className="flex justify-end gap-2 pt-2">
							<Button variant="outline" onClick={() => modalStore.close?.()} disabled={api.loading}>
								Cancel
							</Button>

							<Button onClick={onSave} disabled={api.loading}>
								{api.loading ? "Saving..." : "Save"}
							</Button>
						</div>
					</div>
				</div>
			</>
		);
	},
);
